/**
 * Configurations related to external integrations for the web app
 */
export const HELPCRUNCH_ENVIRONMENT_KEY =
  process.env.REACT_APP_HELPCRUNCH_ENVIRONMENT_KEY ||
  'e6e03cdd-8937-43da-b341-a819c9e43f0a';

export const FRONT_ENVIRONMENT_KEY =
  process.env.REACT_APP_FRONT_ENVIRONMENT_KEY ||
  '1de90d16bdd78c65bacf3bb516bb6d48';

export const FRONT_USER_HASH =
  process.env.REACT_APP_FRONT_USER_HASH || '0e55409bec0c082d4fdcd6dd445a63a2';

/**
 * Application URLs
 */
export const PRIVACY_POLICY_URL =
  process.env.REACT_APP_PRIVACY_POLICY_URL ||
  'https://www.getkanda.com/privacy-policy';

export const TERMS_AND_CONDITIONS_URL =
  process.env.REACT_APP_LEGAL_PAGE || 'https://www.getkanda.com/legal-page';

export const COOKIE_POLICY_URL =
  process.env.REACT_APP_COOKIE_POLICY_URL ||
  'https://www.getkanda.com/cookie-policy';

export const RECAPTCHA_SITE_KEY =
  process.env.REACT_APP_RECAPTCHA_SITE_KEY ||
  '6Lcrc3ImAAAAAPPx3ppenG9jWLk3O5XuFRZi5Abj';
